<template>
  <div id="popup" v-if="isShow">
    <div class="modal">
      <div class="black_bg"></div>
      <div class="popup_cont">
        <div class="text">
          <p>{{ popup.title }}</p>
          <span>{{ popup.content }}</span>
        </div>
        <div class="button">
          <button
            v-if="popup.leftBtnName?.length"
            @click="popup.onLeftBtn"
            class="no"
          >
            {{ popup.leftBtnName }}
          </button>
          <button
            @click="popup.onRightBtn"
            class="yes"
            :class="{ only: !popup.leftBtnName?.length }"
          >
            {{ popup.rightBtnName }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";

export default {
  name: "BasePopup",
  setup() {
    const isShow = ref(false);
    const popup = ref({});
    const openPopup = (popupInfo) => {
      isShow.value = true;
      popup.value = popupInfo;
    };
    const closePopup = () => {
      isShow.value = false;
    };
    return {
      openPopup,
      closePopup,
      popup,
      isShow,
    };
  },
};
</script>

<style lang="scss" scoped>
#popup .modal .popup_cont .button button.yes.only {
  border: 0;
}
</style>
